import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  DropdownItem,
  DropdownMenu,
  UncontrolledCollapse,
  DropdownToggle,
  Dropdown,
  FormGroup,
  Input,
  Tooltip,
} from "reactstrap";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import {
  ADMIN_AGENCY_REPORT,
  STATE_LIST,
  AGENCY_LIST,
} from "../../../constants/ApiPaths";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";
import Select from "react-select";
import AgencyImage from "../../../constants/Images/defaultAgency-1.png";
import generatePDF from "./reportGenerator";
import { CSVLink } from "react-csv";
import { Info } from "../../common/Info";
function AgencyReport() {
  const [agencyReport, setagencyReport] = useState([]);
  const [loading, setLoading] = useState(false);
  let rowperpage=10
  const [SelectState, setSelectState] = useState([]);
  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [filteragencyName, setFilteragencyName] = useState("");
  const [options, setoptions] = useState([]);
  const [filterState, setfilterState] = useState("");
  const [selectagency, setselectagency] = useState("");
  const [agencyId, setagencyId] = useState("");
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const selectInputRef = useRef();
  const headers = [
    { label: "Agency Name", key: "agencyName" },
    { label: "Email", key: "agencyEmail" },
    { label: "License Count", key: "licenseCount" },
    { label: "Convenience Fee", key: "convenienceFee" },
    { label: "Kennel Count", key: "kennelLicenceCount" },
    { label: "Total Payment", key: "totalPayment" },
    { label: "Customer Count", key: "customerCount" },
    { label: "Created Date", key: "createdDate" },
  ];
  const [data, setdata] = useState([]);

  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let getAgenyReport = async (agencyId, filterState) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: ADMIN_AGENCY_REPORT,
      headers: authHeader(),
      params: {
        offset: currentpage,
        count: rowperpage,
        agencyId: agencyId,
        stateId: filterState,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setagencyReport(data);
        const value = data.map((data) => ({
          agencyName: data.agencyName,
          agencyEmail: data.agencyEmail,
          licenseCount: data.licenseCount,
          convenienceFee: data.convenienceFee,
          kennelLicenceCount: data.kennelLicenceCount,
          totalPayment: data.totalPayment,
          customerCount: data.customerCount,
          createdDate: data.createdDate,
        }));
        setdata(value);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  let GetState = async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  let stateFiltreHandle = (e) => {
    setCurrentPage(0);
    setfilterState(e.target.value);
  };

  let Clear = () => {
    selectInputRef.current.select.clearValue();
    setFilteragencyName("");
    setfilterState("");
  };

  const delaySearch = useRef(
    debounce((agencyId, filterState) => getAgenyReport(agencyId, filterState))
  ).current;

  useEffect(() => {
    delaySearch(agencyId, filterState);
  }, [agencyId, filterState]);

  useEffect(() => {
    GetState();
  }, []);

  let getAgency = async (selectagency) => {
    const config = {
      method: "GET",
      url: AGENCY_LIST,
      headers: authHeader(),
      params: {
        count: 10,
        agencyName: selectagency,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setoptions(
          data.map((d) => ({ value: d.agencyId, label: d.agencyName }))
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  let OptionHandle = (e) => {
    if (e !== null) {
      const { value } = e;
      setCurrentPage(0);
      setagencyId(value);
    } else {
      setselectagency("");
      setagencyId("");
      setCurrentPage(0);
    }
  };
  let OptionInputHandle = (text) => {
    setselectagency(text);
  };
  const AgencySearch = useRef(
    debounce((selectagency, agencyId) => getAgency(selectagency, agencyId))
  ).current;

  useEffect(() => {
    //callList();
    AgencySearch(selectagency, agencyId);
  }, [selectagency, agencyId]);

  useEffect(() => {
    getAgenyReport(agencyId, filterState);
  }, [currentpage, filteragencyName]);
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  let Export = () => {
    generatePDF(agencyReport);
  };

  return (
    <div>
      {loading && <CustomPageLoading />}

      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Agency Report
              <Tooltip
                isOpen={id === "agencyreport" && tooltipOpen}
                target={"agencyreport"}
                toggle={() => tooltiptoggle("agencyreport")}
              >
                Report information for each registered agency
              </Tooltip>
              <span id={"agencyreport"}>
                <Info />
              </span>
            </h4>

            <div className="top-btn">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle color="danger" caret>
                  Export
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={Export}>PDF</DropdownItem>
                  <DropdownItem>
                    <CSVLink
                      filename={"AgecnyReport.csv"}
                      data={data}
                      headers={headers}
                    >
                      CSV
                    </CSVLink>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Button id="toggler" color="link">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>
            </div>
          </div>

          <div className="mt-4">
            <UncontrolledCollapse toggler="#toggler">
              <Card body>
                <Row className="mt-3">
                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select Agency</span>
                      <Select
                        options={options}
                        isClearable={true}
                        placeholder="Select Agency "
                        ref={selectInputRef}
                        onChange={OptionHandle}
                        onInputChange={OptionInputHandle}
                      />{" "}
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select State</span>
                      <Input
                        type="select"
                        name="stateId"
                        value={filterState}
                        onChange={stateFiltreHandle}
                        id=""
                        placeholder="Enter hyperlink"
                      >
                        <option value="">Select State</option>
                        {SelectState.map((i) => (
                          <option key={i.stateId} value={i.stateId}>
                            {i.stateName}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3">
                    <Button color="danger" className="mt-4" onClick={Clear}>
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Card>
            </UncontrolledCollapse>
          </div>

          <Card body className="mt-4">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>State</th>
                  <th>License count</th>
                  <th>Convenience Fee</th>
                  <th>Kennel count</th>
                  <th>Total Payment</th>
                  <th>Customer count</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  ""
                ) : (
                  <>
                    {agencyReport.length === 0 ? (
                      <tr>
                        <td colSpan={9}>
                          <center>No Record Found</center>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {agencyReport.map((report, index) => (
                          <tr>
                            <td>
                              {" "}
                              <div className="user-box">
                                <img
                                  style={{ marginRight: "8px" }}
                                  src={
                                    report.agencyLogo === ""
                                      ? AgencyImage
                                      : report.agencyLogo
                                  }
                                  alt=""
                                />
                                {report.agencyName}
                              </div>
                            </td>
                            <td>{report.agencyEmail}</td>
                            <td>{report.stateName}</td>
                            <td>{report.licenseCount || 0}</td>
                            <td>
                              $
                              {parseFloat(report.convenienceFee || 0).toFixed(
                                2
                              )}
                            </td>
                            <td>{report.kennelLicenceCount || 0}</td>
                            <td>
                              ${parseFloat(report.totalPayment || 0).toFixed(2)}
                            </td>
                            <td>{report.customerCount || 0}</td>
                          </tr>
                        ))}
                      </>
                    )}{" "}
                  </>
                )}
              </tbody>
            </Table>
            <div className="d-flex flex-row py-4 justify-content-end">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentpage + 1}
                itemsCountPerPage={rowperpage}
                totalItemsCount={totalrecords}
                onChange={onPageChange}
              />
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default AgencyReport;
